module.exports = __webpack_public_path__ + "img/step-1-car.4bda5382.svg";